export const LICENSE_INPUT_TYPES = {
  GRADES: 'grades',
  REGIONS: 'regions',
};
